import { Box } from '@mui/joy';
import { SxProps } from '@mui/material';
import { Viewer } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';

import { pageThumbnailPlugin } from './pageThumbnailPlugin';

interface IProps {
  fileUrl: string;
  onClick?: () => void;
  pageIndex?: number;
  wrapperSxProps?: SxProps;
}

export const PdfThumbnail = ({ fileUrl, onClick, pageIndex = 0, wrapperSxProps }: IProps) => {
  const thumbnailPluginInstance = thumbnailPlugin();

  const { Cover } = thumbnailPluginInstance;

  const pageThumbnailPluginInstance = pageThumbnailPlugin({
    PageThumbnail: <Cover getPageIndex={() => pageIndex} />,
  });

  return (
    <Box sx={wrapperSxProps} onClick={onClick}>
      <Viewer fileUrl={fileUrl} plugins={[pageThumbnailPluginInstance, thumbnailPluginInstance]} />
    </Box>
  );
};
